<template>
  <div class="envelope-rejection-reason-overlay">
    <p class="small">
      <strong>Decline reason:</strong> {{rejectionReason}}
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  props: {
    rejectionReason: ''
  },
  methods: {
  },
  created() {
  }
}
</script>

<style lang="scss" scoped>
  .envelope-rejection-reason-overlay {
    background-color: white;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  }
</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-envelopes/EnvelopeRejectInfo.vue